import { MutationTree } from 'vuex'
import { UserManagementStateInterface } from '@/models/store/UserManagementState.interface'
import { UserInterface } from '@/models/users/User.interface'
import { FeatureInterface } from '@/models/users/Feature.interface'

const mutations: MutationTree<UserManagementStateInterface> = {
  loading(state: UserManagementStateInterface) {
    state.loading = true
  },
  loaded(state: UserManagementStateInterface) {
    state.loading = false
  },
  saving(state: UserManagementStateInterface) {
    state.saving = true
  },
  saved(state: UserManagementStateInterface) {
    state.saving = false
  },
  updateUsers(state: UserManagementStateInterface, users: UserInterface[]) {
    state.users = users
  },
  updateFeatures(
    state: UserManagementStateInterface,
    features: FeatureInterface[]
  ) {
    state.features = features
  }
}

export default mutations
